// extracted by mini-css-extract-plugin
export default {"mainContainer":"Error404_mainContainer__r689K","topContainer":"Error404_topContainer__Cx9dU","bottomContainer":"Error404_bottomContainer__JKBD3"};